import React, { useEffect, useRef, useState } from "react";
import wiselogo from '../../images/wise.svg';
import { userService } from "../../_services";
import * as z from 'zod';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { US_STATES, BANK_ACCOUNT_TYPES } from '../../utils/constants';

const w9FormSchema = z.object({
    Address: z.string()
        .min(1, 'Please input valid street address')
        .max(25, 'Please input valid street address'),
    State: z.string()
        .min(1, 'Please select State')
        .refine(val => val !== 'Please select state', 'Please select State'),
    City: z.string()
        .refine(val => val.length >= 2 && val.length <= 35, 'Please input valid city'),
    Zip: z.string()
        .refine(val => val.length === 5, 'Please input valid zipcode'),
    RoutingNumber: z.string()
        .refine(val => val.length === 9, 'Please input valid Routing Number'),
    AccountNumber: z.string()
        .refine(val => val.length >= 4 && val.length <= 17, 'Please input valid Account Number'),
    AccountType: z.string()
        .min(1, 'Please select Account Type')
        .refine(val => val !== 'Account Type', 'Please select Account Type'),
});

const W9FormStarter = ({ closeStarterForm, type, threshold }) => {
    const [status, setStatus] = useState("");
    const [w9Submitted, setW9Submitted] = useState(true);
    const [w9Success, setW9Success] = useState('init');
    const [showPaymentForm, setShowPaymentForm] = useState(false)
    const [formDetailsLoaded, setFormDetailsLoaded] = useState(false)
    const [w9processing, setW9processing] = useState(true)
    const [w9AlertMsg, setW9AlertMsg] = useState('')
    const scriptLoaded = useRef(false);
    const formRequestRef = useRef(null);
    const [formState, setFormState] = useState({
        UserId: '',
        Address: '',
        Country: 'United States',
        State: '',
        City: '',
        Zip: '',
        fullName: '',
        carddetails: '',
        title: 'Payment Information',
        loader: false,
        Isshowpayment: false,
        show_Userdetail_popup: true,
        SuccessMessage: false,
        confirm: false,
        orderid: '',
        gn: '',
        date: '',
        email: '',
        name: '',
        show_confirm_popup: false,
        RoutingNumber: '',
        AccountNumber: '',
        AccountType: '',
        accountSummary: '',
        bankName: '',
        textSummary: '',
    });

    const [errors, setErrors] = useState({
        Address: '',
        State: '',
        City: '',
        Zip: '',
        orderid: '',
        gn: '',
        date: '',
        RoutingNumber: '',
        AccountNumber: '',
        AccountType: '',
        saveSubmit: ''
    });

    // US_STATES and BANK_ACCOUNT_TYPES imported from utils/constants

    const fetchuserDetails = () => {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        return { userId: Usermeta_Data.split(':')[0], userName: Usermeta_Data.split(':')[1] }
    }

    const FetchBankTaxDetails = () => {
        const { userId, userName } = fetchuserDetails()
        userService.FetchBankTaxDetails(userId, userName)
            .then(
                apidata => {
                    if (apidata && apidata.length) {
                        if (!apidata[0].w9_Status?.length || !apidata[0].w9_Status[0]?.referenceId || !apidata[0].w9_Status[0]?.signedDate) {
                            FetchW9FormData()
                            setW9Submitted(false)
                        }
                        if (apidata[0].w9_Status?.length && apidata[0].w9_Status[0]?.referenceId && apidata[0].w9_Status[0]?.signedDate) {
                            setW9Success('submitted')
                        }
                        if (apidata[0].wise_Summary && apidata[0].wise_Summary.length) {
                            setFormState(prev => ({
                                ...prev,
                                UserId: userId,
                                accountSummary: apidata[0].wise_Summary[0].acc_Summary,
                                AccountType: apidata[0].wise_Summary[0].acc_Type,
                                bankName: apidata[0].wise_Summary[0].bank_Name,
                                textSummary: apidata[0].wise_Summary[0].text_Summary,
                                Address: apidata[0].wise_Summary[0].address,
                                State: apidata[0].wise_Summary[0].state,
                                City: apidata[0].wise_Summary[0].city,
                                email: apidata[0].wise_Summary[0].email,
                                name: apidata[0].wise_Summary[0].fullName,
                                Zip: apidata[0].wise_Summary[0].zip
                            }))
                            if (!apidata[0].wise_Summary[0].acc_Summary || !apidata[0].wise_Summary[0].text_Summary) {
                                setShowPaymentForm(true)
                            } else {
                                setShowPaymentForm(false)
                            }
                            setFormDetailsLoaded(true)
                        }
                    }
                })
    }

    const FetchW9FormData = () => {
        let getlogin = window.location.href;
        let w9transactionurl = "";
        if (getlogin.toLowerCase().includes("release-backoffice") || getlogin.toLowerCase().includes("dev-backoffice") || getlogin.toLowerCase().includes("localhost:") || getlogin.toLowerCase().includes("shadcn-backoffice")) {
            w9transactionurl = "https://sbx.track1099.com/api/request_form.js";
        } else {
            w9transactionurl = "https://www.track1099.com/api/request_form.js";
        }
        const { userId, userName } = fetchuserDetails()
        userService.FetchRequestW9Form(userId, userName)
            .then(
                apidata => {
                    if (apidata?.data) {
                        //const closedUntil = localStorage.getItem("w9_form_closed_until");
                        //const now = Date.now();

                        /*if (!closedUntil || now > parseInt(closedUntil)) {
                            setTimeout(() => {
                                setShowModal(true);
                            }, 5000)
                        }*/

                        if (!scriptLoaded.current) {
                            const script = document.createElement("script");
                            script.src = w9transactionurl;// "https://www.track1099.com/api/request_form.js";
                            script.type = "module";
                            script.crossOrigin = "anonymous";

                            script.onload = () => {
                                scriptLoaded.current = true;
                                formRequestRef.current = apidata.data;
                                updateStatus(apidata.data);
                            };

                            document.body.appendChild(script);
                        }
                    }
                }
            );
    }

    const FetchReviseW9 = () => {
        const { userId, userName } = fetchuserDetails()
        userService.FetchReviseW9(userId, userName)
            .then(
                apidata => {
                    setW9processing(false)
                    if (apidata && apidata.length) {
                        if (apidata[0].referenceId && apidata[0].signedDate) {
                            setW9Success('submitted')
                            setW9Submitted(true)
                        } else {
                            setW9Success('failed')
                            setW9Submitted(false)
                        }
                    } else {
                        setW9Success('init')
                        setW9Submitted(false)
                    }
                }
            );
    }

    useEffect(() => {
        FetchBankTaxDetails()
    }, [])

    const updateStatus = (request, incompleteValue = "") => {
        const signedAt = request?.data?.attributes?.signed_at;
        if (signedAt) {
            const date = new Date(signedAt).toLocaleString("en-US", {
                dateStyle: "medium",
                timeStyle: "short"
            });
            setStatus(`Signed ${date}`);
        } else {
            setStatus(incompleteValue);
        }
        FetchReviseW9()
    };

    const handleStartW9 = () => {
        setW9AlertMsg('');
        setW9processing(true)
        if (!window.Avalara1099 || !formRequestRef.current) {
            setW9AlertMsg("Form is not ready yet.");
            return;
        }

        window.Avalara1099.requestW9(formRequestRef.current, {
            prefill: {
                name: formState.name,
                email: formState.email
            }
        })
            .then((newRequest) => {
                formRequestRef.current = newRequest;
                updateStatus(newRequest, "Incomplete");
            })
            .catch((errors) => {
                setW9processing(false)
                console.error("ERRORS", errors);
                if (errors?.errors?.[0]?.status === "404") {
                    setW9AlertMsg("FormRequest expired or already used. Create a new FormRequest and try again.");
                } //else {
                //alert("Something went wrong.");
                //}
            });
    };

    const handleInput = (e) => {
        const { name, value } = e.target;
        let sanitizedValue = value;

        if (["Zip", "RoutingNumber", "AccountNumber"].includes(name)) {
            sanitizedValue = value.replace(/[^0-9]/g, '');
        }

        setFormState(prev => ({ ...prev, [name]: sanitizedValue }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const removeError = (e) => {
        const name = e.target.previousElementSibling?.previousElementSibling?.name;
        if (name) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const submitUserDetail = () => {
        const { Address, State, City, Zip, RoutingNumber, AccountNumber, AccountType } = formState;

        const result = w9FormSchema.safeParse({ Address, State, City, Zip, RoutingNumber, AccountNumber, AccountType });
        const fe = result.success ? {} : result.error.flatten().fieldErrors;

        // Start with current errors (preserving non-validated fields like orderid, gn, etc.)
        const newErrors = { ...errors };
        if (fe.Address?.[0]) newErrors.Address = fe.Address[0];
        if (fe.State?.[0]) newErrors.State = fe.State[0];
        if (fe.City?.[0]) newErrors.City = fe.City[0];
        if (fe.Zip?.[0]) newErrors.Zip = fe.Zip[0];
        if (fe.RoutingNumber?.[0]) newErrors.RoutingNumber = fe.RoutingNumber[0];
        if (fe.AccountNumber?.[0]) newErrors.AccountNumber = fe.AccountNumber[0];
        if (fe.AccountType?.[0]) newErrors.AccountType = fe.AccountType[0];

        setErrors(newErrors);

        const isValid = Object.values(newErrors).every(val => val === '');
        if (!isValid) return;

        saveAddress();
    };

    const saveAddress = () => {
        const { UserId, Address, Country, State, City, Zip, RoutingNumber, AccountNumber, AccountType } = formState;
        setFormState(prev => ({ ...prev, loader: true }));

        userService.SaveAddress(UserId, Address, Country, State, City, Zip, RoutingNumber, AccountNumber, AccountType).then(apidata => {
            if (apidata?.[0]?.code !== '-1') {
                setFormState(prev => ({ ...prev, loader: false }));
                FetchBankTaxDetails()
            } else {
                setErrors(prev => ({ ...prev, saveSubmit: apidata?.[0]?.message || '' }));
                setFormState(prev => ({ ...prev, loader: false }));
            }
        });
    };

    const toggleConfirmPopupClick = () => {
        document.body.classList.toggle('confirm');
        setFormState(prev => ({ ...prev, show_confirm_popup: true }));
    };

    const doFocus = (e) => {
        const input = e.target.previousElementSibling;
        if (input) input.focus();
    };
    const togglePaymentForm = () => {
        setShowPaymentForm(!showPaymentForm)
    }

    const { loader, Address, State, City, Zip, RoutingNumber, AccountNumber, AccountType, accountSummary, textSummary, bankName } = formState;

    return (
        <Dialog open={true} onOpenChange={closeStarterForm}>
            <DialogContent className="max-w-4xl w-full">
                <DialogHeader>
                    <DialogTitle>Payout Details</DialogTitle>
                </DialogHeader>
                    <div className="modal_body">
                        {/* swapped: bank details now on the left */}
                        <div className="right paymentForm">
                            <div className="paymentFormHeader">
                                <div className="headerLeft">
                                    <h3>{type === 'edit' ? 'Edit your Bank Account' : 'Link your Bank Account'}</h3>
                                    <p>
                                        {type === 'edit'
                                            ? <>Add a new bank account to get payments credited directly! NuLifeSpan Rx uses <a href="https://wise.com/" target="_blank" rel="noopener noreferrer">Wise</a> to securely create your payment account and does not store your bank details.</>
                                            : <>Link your bank account to get payments credited directly! NuLifeSpan Rx uses <a href="https://wise.com/" target="_blank" rel="noopener noreferrer">Wise</a> to securely create your payment account and does not store your bank details.</>}
                                    </p>
                                </div>
                            </div>
                            {formDetailsLoaded ? <div className="order-section">
                                <div className="Account_info_form_parent intro-kit">
                                    {
                                        showPaymentForm ? <div className="personal_box UserInfo">
                                            <div className="two-column">
                                                <div className={errors.Address ? 'errors same' : 'same'}>
                                                    <input type="text" name="Address" value={Address} onChange={handleInput} onFocus={handleInput} placeholder=" " />
                                                    <span onClick={doFocus}>Address</span>
                                                    {errors.Address && <span className="error" onClick={removeError}>{errors.Address}</span>}
                                                </div>
                                                <div className={errors.City ? 'errors same last-name' : 'same last-name'}>
                                                    <input type="text" name="City" value={City} onChange={handleInput} onFocus={handleInput} placeholder=" " />
                                                    <span onClick={doFocus}>City*</span>
                                                    {errors.City && <span className="error" onClick={removeError}>{errors.City}</span>}
                                                </div>
                                            </div>
                                            <div className="two-column">
                                                <div className={errors.State ? 'drpdown errors same first-name' : 'drpdown same first-name'}>
                                                    <Select value={State} onValueChange={(val) => { setFormState(prev => ({ ...prev, State: val })); setErrors(prev => ({ ...prev, State: '' })); }}>
                                                        <SelectTrigger className="w-full">
                                                            <SelectValue placeholder="State*" />
                                                        </SelectTrigger>
                                                        <SelectContent>
                                                            {US_STATES.map(item => (
                                                                <SelectItem key={item.name} value={item.value}>{item.name}</SelectItem>
                                                            ))}
                                                        </SelectContent>
                                                    </Select>
                                                    {errors.State && <span className="error">{errors.State}</span>}
                                                </div>

                                                <div className={errors.Zip ? 'errors same first-name' : 'same first-name'}>
                                                    <input type="text" name="Zip" value={Zip} onChange={handleInput} onFocus={handleInput} placeholder=" " />
                                                    <span onClick={doFocus}>Zip/Postal Code*</span>
                                                    {errors.Zip && <span className="error" onClick={removeError}>{errors.Zip}</span>}
                                                </div>
                                            </div>
                                            <div className="two-column">
                                                <div className={errors.AccountNumber ? 'errors same' : 'same'}>
                                                    <input type="text" name="AccountNumber" value={AccountNumber} onChange={handleInput} onFocus={handleInput} placeholder=" " />
                                                    <span onClick={doFocus}>Bank Account Number*</span>
                                                    {errors.AccountNumber && <span className="error" onClick={removeError}>{errors.AccountNumber}</span>}
                                                </div>

                                                <div className={errors.RoutingNumber ? 'errors same' : 'same'}>
                                                    <input type="text" name="RoutingNumber" value={RoutingNumber} onChange={handleInput} onFocus={handleInput} placeholder=" " />
                                                    <span onClick={doFocus}>Bank Routing Number*</span>
                                                    {errors.RoutingNumber && <span className="error" onClick={removeError}>{errors.RoutingNumber}</span>}
                                                </div>
                                            </div>
                                            <div className="two-column">
                                                <div className={errors.AccountType ? 'drpdown errors same' : 'drpdown same'}>
                                                    <Select value={AccountType} onValueChange={(val) => { setFormState(prev => ({ ...prev, AccountType: val })); setErrors(prev => ({ ...prev, AccountType: '' })); }}>
                                                        <SelectTrigger className="w-full">
                                                            <SelectValue placeholder="Account Type*" />
                                                        </SelectTrigger>
                                                        <SelectContent>
                                                            {BANK_ACCOUNT_TYPES.map(item => (
                                                                <SelectItem key={item.name} value={item.value}>{item.name}</SelectItem>
                                                            ))}
                                                        </SelectContent>
                                                    </Select>
                                                    {errors.AccountType && <span className="error">{errors.AccountType}</span>}
                                                </div>
                                            </div>

                                            <div className="footer shadow-none">
                                                <div className={loader ? "yes_btn loader" : "yes_btn"} onClick={submitUserDetail}>
                                                    Save & Continue
                                                </div>
                                                {accountSummary ? <div className="yes_btn" onClick={togglePaymentForm}>
                                                    Cancel
                                                </div> : null}
                                                <a href="https://wise.com/" target="_blank" rel="noopener noreferrer" className="w-20 flex ml-auto"><img src={wiselogo} className="max-w-full" /></a>
                                            </div>

                                            {errors.saveSubmit && <p className="text-sm text-destructive">{errors.saveSubmit}</p>}
                                        </div>
                                            :
                                            <div className="payments">
                                                <h4>Payments <span className="edit" onClick={togglePaymentForm}>Edit</span></h4>
                                                <div className="account-number">
                                                    <div>Account Number: <label>{accountSummary}</label></div>
                                                    <div>Text Summary: <label>{textSummary}</label></div>
                                                    <div>Account Type: <label>{AccountType}</label></div>
                                                    <div>Bank Name: <label>{bankName}</label></div>
                                                </div>
                                                <a href="https://wise.com/" target="_blank" rel="noopener noreferrer" className="w-20 flex ml-auto"><img src={wiselogo} className="max-w-full" /></a>
                                            </div>
                                    }
                                </div>
                            </div> : null}
                        </div>

                        {/* swapped: tax details now on the right */}
                        <div className="left">
                            <h3>Provide your Tax Information</h3>
                            <p>
                                Fill out your W-9 information once you cross the $450 annual threshold to continue getting payments!
                                NuLifeSpan Rx uses <a href="https://www.avalara.com/us/en/index.html" target="_blank" rel="noopener noreferrer">Avalara</a> to securely process your personal information and generate a Form 1099 for your tax returns.
                            </p>
                            {!w9Submitted ? <>
                                <Button
                                    type="button"
                                    variant="secondary"
                                    onClick={handleStartW9}
                                    disabled={w9processing || threshold < 450}
                                >
                                    Start Form W-9
                                </Button>
                                {threshold >= 450 ? <p className="mt-2.5">Note that you have crossed the annual payment threshold and will need to submit your tax information in order to continue receiving payments.</p> : null}
                                {w9AlertMsg && (
                                    <Alert variant="destructive" className="mt-2">
                                        <AlertCircle className="h-4 w-4" />
                                        <AlertDescription>{w9AlertMsg}</AlertDescription>
                                    </Alert>
                                )}
                            </> : null}
                            {w9Success === 'submitted' ? <div className="mt-4 flex flex-col items-center gap-3">
                                <img src="data:image/png;base64,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" className="w-16 h-auto" />
                                <p className="text-sm text-primary font-medium">W9 form submitted successfully.</p>
                            </div> : w9Success === 'failed' ? <div className="mt-4"><p className="text-sm text-primary/70">We'll review your W9 form detail.</p></div> : null}
                        </div>
                    </div>
            </DialogContent>
        </Dialog>
    );
};

export default W9FormStarter;